import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import {exhibitionlist, api} from '../../apis/urls'
import Loader from '../../common-components/loader'
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import moment from "moment";
import { Badge, Pagination } from "antd";
import { decode } from "html-entities";
import { Button, Grid, Input, Modal, Row, Text } from "@nextui-org/react";
import { message, Popconfirm, Switch, Modal as Modals } from "antd";

const ExhibitionRegisterList =()=> {


    const [loader,setLoader] = useState(false);
    const [result, setResult] = useState([]);
    const [ids, setIds] = useState(null);
    const [details, setDetails] = useState('');
    const [title, setTitle] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
        });
    }, []);

    

    const {id} = useParams();

   

    const page = new URLSearchParams(useLocation().search).get('page')



    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: `${exhibitionlist}/register/${id}?size=2000`,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            if(res?.data?.message === "Success"){            
                setResult(res?.data?.data);
            }
            setTitle(res?.data?.exhibition);
            setLoader(false)
        });
    }

    // new code 

    const exportExhibitor  = () => { 

        let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: api+"impex/exhibitor/export/attendee/"+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            message.success("Export successfully")
            window.open(api+"impex/download/exhibitor/"+response.data.fileName, '_blank')
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
}


    // new code end 

    const [visible, setVisible] = useState(false);
    const handler = (id) => {
        setVisible(true)
        setIds(id)
    };

    const closeHandler = () => {
        setVisible(false);
    };

    const paymentStatusChange = () => {

        let token = "Bearer "+localStorage.getItem('token');
      
        const data = {
          id:ids,
          payment_details:details
        }
      
        const instance = axios.create({
      
            baseURL: `${exhibitionlist}/register/approve/payment`,
      
            timeout: 1000000,
      
            headers: {'authorization': token}
      
          });
          
          instance.patch('', data).then((response) =>{
      
            closeHandler();
      
            setTimeout(() => {
                Listing();
            },[500]);

          }).catch((error) =>{
            
          });
      
      }

      const handleChange = (e) => {
        setDetails(e.target.value)
      }
      

    
    return(
        <div>
        <aside class="right-side areas">
			<div class="content-area dash-contentss">
                <div class="page-title-wrpr">
                <div class="page-title-left-column">
                    <i class="icon-library1"></i>
                    <h2 class="page-title"> Exhibitors List - {title?.name}</h2>
                </div>
                {/* <div className="page-rightside-action-column">                          
                    <Badge count={pending}>
                        <Link to={"/exhibition_register_pending/"+id} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Event"><span>Payment Pending</span> </Link>
                    </Badge>
                </div> */}
            </div>
             
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/exhibition">Exhibitor</Link></li>
                <li class="breadcrumb-item active" aria-current="page">Exhibitors List</li>
              </ol>
            </nav>

            {result?.items &&
            <div class="number-of" style={{marginBottom:'20px'}}>
                Displaying {result?.currentPage * 10 + 1}-{result?.currentPage * 10 + result?.items?.length} of {result?.totalItems} results.
            </div>
            }
            <div className="page-rightside-action-column mb-3">    
                <button onClick={exportExhibitor} style={{padding:"10px", background:'#4077c7', borderRadius:"5px", color:'#fff'}} className="addbtnitem-link text-anchor">Export</button>
            </div>
            <div className="containers" style={{overflow:'auto'}}>
                {result?.items &&
                    <table className="table table-rules">
                        <thead>
                            <tr className="rules-table-head">
                                <th scope="col">Sl.No</th>
                                <th scope="col">Company</th>
                                <th scope="col">Name</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Payment Mode</th>
                                <th scope="col">Payment Status</th>
                                <th scope="col">No.of Tables</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Electricity</th>
                                <th scope="col" style={{textAlign:'center'}}>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className="rules-table-content">
                            {result?.items?.map((item,index) =>(
                                <tr key={index} style={{background:item?.publish_status === 'PENDING'?'#f0f0f0':'#fff'}}>
                                    <td style={{verticalAlign:'middle', fontWeight:500}} scope="row">
                                        {(index+1)+result.currentPage*10}
                                    </td>
                                    <td style={{verticalAlign:'middle', fontWeight:500}}>
                                        {decode(item?.organization)}
                                    </td>
                                    <td style={{verticalAlign:'middle', fontWeight:500}}>
                                        {decode(item?.fname)} {decode(item?.lname)}
                                    </td>
                                    <td style={{verticalAlign:'middle', fontWeight:500}}>
                                        {item?.phone}
                                    </td>
                                    <td style={{verticalAlign:'middle', fontWeight:500}}>
                                        <span 
                                            class="desig" 
                                            style={{fontWeight:600, color:item.payment_type ==="CHECK"?"green":"blue"}}>
                                            <i 
                                                className={item.payment_type === "CHECK"?"icon-banknote":"icon-creditcards"} 
                                                style={{fontSize:"18px"}}
                                            ></i>&nbsp;&nbsp;{item.payment_type}
                                        </span>
                                    </td>
                                    <td onClick={()=> item.payment === "PENDING" && handler(item.id)} style={{verticalAlign:'middle', fontWeight:500, cursor:item.payment === "PENDING" && 'pointer' }}>
                                        <span 
                                            class="desig" 
                                            style={{fontWeight:600, color:item.payment ==="PAID"?"green":"blue"}}>
                                            <i 
                                                className={item.payment === "PENDING"?"icon-hour-glass":"icon-checkmark4"} 
                                                style={{fontSize:"18px"}}
                                            ></i>&nbsp;&nbsp;{item.payment}
                                        </span>
                                    </td>
                                    <td  style={{verticalAlign:'middle', fontWeight:500}}>
                                        {item?.table_num}
                                    </td>
                                    <td  style={{verticalAlign:'middle', fontWeight:500}}>
                                        $ {parseFloat(item?.amount).toFixed(2)}
                                    </td>
                                    <td  style={{verticalAlign:'middle', fontWeight:500}}>
                                        {item?.electricity === "YES"?"Yes":"No"}
                                    </td>
                                    <td style={{verticalAlign:'middle'}}>
                                        <div className="list-action-wrpr showicons roundicons-text" >
                                            <div className="list-action-wrpr">
                                            
                                                <button onClick={()=>{navigate(`/exhibitor_view/${item.id}`)}} style={{top:"-20px"}} data-toggle="tooltip" title="View">
                                                    <i className="jobs icon-eye" style={{background:'#FF577F'}}></i>
                                                    <span>&nbsp;View&nbsp;</span>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                
                                </tr>
                            ))}
                            <tr>
                                <td colSpan={2}/>
                                <td colSpan={3} style={{fontWeight:500, textAlign:'left', fontSize:'15px'}}>Total Table</td>
                                <td/>
                                <td colSpan={5} style={{fontWeight:500, textAlign:'left', fontSize:'15px'}}>{result?.items?.reduce((a, b) => a + (b['table_num'] || 0), 0)}</td>
                            </tr>
                        </tbody>   
                    </table>
                } 
            </div>

            {
                !result?.items && !loader &&
                <div className="nodata" style={{marginTop:'10%'}}>
                    <h2>Sorry! No Result Found</h2>
                </div>
            }

            {result?.items &&
                <div class="number-of"  style={{marginTop:'10px'}}>
                    Displaying {result?.currentPage * 10 + 1}-{result?.currentPage * 10 + result?.items?.length} of {result?.totalItems} results.
                </div>
            }

            { 
                loader && 
                <div className="loader" style={{textAlign:'center', marginTop:'20%'}}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            }


                <Modal
                    closeButton
                    aria-labelledby="modal-title"
                    open={visible}
                    onClose={closeHandler}
                >
                    <Modal.Header>
                        <Text h1 size={30} 
                        css={{textGradient: "45deg, $yellow600 -20%, $red600 100%"}} weight="bold">
                            Confirmation
                        </Text>
                    </Modal.Header>
                    <Modal.Body style={{width:'100%'}}>
                        <Row style={{width:'100%'}} justify="space-between">
                        <Input onChange={(value)=>handleChange(value)} style={{width:'100%'}} className="text-area-pending" as="textarea" rows={3} placeholder="Enter Something" />
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Grid.Container>
                        <Grid xs={6} style={{justifyContent:'flex-start'}}>
                            <Button auto flat color="error" onClick={closeHandler} style={{width:'60%', borderRadius:'5px', padding:'18px'}}>
                            <Text style={{fontSize:'12px',color:'crimson', fontWeight:'900'}}>Close</Text>
                            </Button>
                        </Grid>
                        <Grid xs={6} style={{justifyContent:'flex-end'}}>
                            <Button auto onClick={paymentStatusChange} style={{width:'60%', borderRadius:'5px', padding:'18px'}}>
                            <Text style={{fontSize:'12px',color:'#fff', fontWeight:'900'}}>Confirm</Text>
                            </Button>
                        </Grid>
                        </Grid.Container>
                    </Modal.Footer>
                </Modal>


        </div>
        </aside>
    </div>
    );
}

export default ExhibitionRegisterList;